import { FinanceDateType } from '@trnsact/trnsact-shared-types';
import { FinanceFilters, FinanceFilterType } from './types';

export const initialFinanceFiltersValue: FinanceFilters = {
  [FinanceFilterType.DEAL_DATE]: 'cm',
  // Paired with DEAL_DATE (used only when it's 'custom'), not a standalone filter type.
  customDateRange: null,
  [FinanceFilterType.SALES_REP]: [],
  [FinanceFilterType.LOCATION]: [],
  [FinanceFilterType.PAYMENT_TYPE]: 'ALL' as const,
  [FinanceFilterType.DEAL_STATUS]: 'ALL',
  [FinanceFilterType.DATE_TYPE]: FinanceDateType.CreatedOn,
};
